import { render, staticRenderFns } from "./SliderCards.vue?vue&type=template&id=a83d394c&scoped=true"
import script from "./SliderCards.vue?vue&type=script&lang=js"
export * from "./SliderCards.vue?vue&type=script&lang=js"
import style0 from "./SliderCards.vue?vue&type=style&index=0&id=a83d394c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a83d394c",
  null
  
)

export default component.exports